import { ChangeDetectionStrategy, Component, computed, input, model, signal } from "@angular/core";
import { ServiceHoursStatus } from "./service.hours.service";
import { S25ButtonComponent, ButtonClassSuffix } from "../../../standalone/s25.button.component";
import { Bind } from "../../../decorators/bind.decorator";

@Component({
    selector: "service-hour-status",
    template: `
        <div class="status-group">
            @for (option of availableOptions(); track option.value) {
                <s25-ng-button
                    [type]="option.buttonType"
                    [onClick]="selectStatus"
                    [onClickArgs]="[option.value]"
                    [isLoading]="approvalLoading() && option.value === seHoursStatus.Approved"
                >
                    {{ option.label }}
                </s25-ng-button>
            }
        </div>
    `,
    styles: `
        .status-group {
            display: flex;
            flex-wrap: wrap;
            gap: 0.75rem;
        }

        :host(.compact) .status-group {
            gap: 0.5rem;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [S25ButtonComponent],
})
export class ServiceHourStatusComponent {
    readonly status = model.required<ServiceHoursStatus>();
    readonly showPending = input(true);

    protected approvalLoading = signal(false);
    protected seHoursStatus = ServiceHoursStatus;

    readonly options: {
        value: ServiceHoursStatus;
        label: string;
        buttonType: ButtonClassSuffix;
    }[] = [
        { value: ServiceHoursStatus.Approved, label: "Approve", buttonType: "primary" },
        { value: ServiceHoursStatus.Pending, label: "Pending", buttonType: "outline" },
        { value: ServiceHoursStatus.Denied, label: "Deny", buttonType: "danger" },
    ];

    readonly availableOptions = computed(() => {
        if (this.showPending()) return this.options;
        return this.options.filter((option) => option.value !== ServiceHoursStatus.Pending);
    });

    @Bind
    selectStatus(value: ServiceHoursStatus) {
        this.status.set(value);
    }

    toggleLoading() {
        this.approvalLoading.update((prev) => !prev);
    }
}
